module.exports = __webpack_public_path__ + "static/media/SpaceGrotesk-Bold.788e7c70.woff2";